<div class="container-fluid font-color-navy container-shadow">
  <span *ngIf="isListloading" class="justify-content-center">
    <app-loading [displayeMessage]="true"></app-loading>
  </span>

  <ng-container *ngIf="!isEditable">
    <div class="button-row float-right">
      <span *ngIf="isListloading==false">
        <app-refresh (click)="ngOnInit()" [buttonDisplay]="true"></app-refresh>
      </span>
      <span *ngIf="isListloading==true">
        <app-refresh [buttonDisplay]="false"></app-refresh>
      </span>
      <button style="float:right;" mat-icon-button matTooltip="Edit Moderator" (click)="onEditClick()" [disabled]="!canModify" [ngClass]="canModify?'font-color-orange':'color-disabled'" aria-label="Edit Moderator">
        <mat-icon aria-hidden="false" aria-label="Edit Moderator" fontIcon="edit_note"></mat-icon>
      </button>
    </div>

    <table mat-table [dataSource]="moderatorsList" class="mat-elevation-z8">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="mat-table-thead"> Moderator </th>
        <td mat-cell *matCellDef="let moderator"><dl><dt class="large">{{moderator.name}}</dt><dd class="small">-{{moderator.unique_Name}}</dd></dl></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>

  <ng-container *ngIf="isEditable">
    <br />
    <div>
      <span matAutocompleteOrigin #moderatorOrigin="matAutocompleteOrigin">
        <mat-form-field class="form-group">
          <input type="text" placeholder="Select Moderator" [formControl]="addModeratorControl" matInput [matAutocomplete]="autoModerator"
                 [matAutocompleteConnectedTo]="moderatorOrigin" class="form-control" required>
          <mat-autocomplete [panelWidth]="'auto'" #autoModerator="matAutocomplete" (optionSelected)="onAddModeratorSelected($event)">
            <mat-option *ngFor="let option of moderatorsfilteredOptions | async" [value]="option.adsId">
              {{option.displayName}} ({{option.login}})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>

      <span class="font-color-orange" style="margin: 0 0 0 30px;">{{this.errorMessage}}</span>
      <span class="float-end">
        <button class="btn-new-ui-xs" style="margin: 0 20px 0 0;" (click)="onCancelClick()">Cancel</button>
        <button [ngClass]="isModified ? 'btn-new-ui-xs':'btn-new-ui-disabled'" (click)="onSaveClick()" [disabled]="!(canModify && isModified)">Save</button>
      </span>
    </div>

    <span *ngIf="isModeratorLoading">
      <app-loading [displayeMessage]="false"></app-loading>
    </span>

    <table class="table table-bordered table-striped" id="modifiedModerators">
      <thead class="table-secondary">
        <tr>
          <th class="font-color-navy">MODERATOR</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let moderator of newModeratorsList; index as i" [attr.id]="moderator.moderatorId">
          <td><dl><dt class="large">{{moderator.name}}</dt><dd class="small">-{{moderator.unique_Name}}</dd></dl></td>
          <td><button id="remove{{moderator.moderatorId}}" (click)="removeModerator(moderator)" [disabled]="!canModify" class="btn-new-ui-xs">Remove</button></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
